<template>
  <v-container class="pt-5 pb-1">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.name"
          type="text"
          hide-details
          label="Nome"
          outlined
          dense
          @input="
            (a) => {
              form.name = a.toUpperCase()
            }
          "
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="form.workload"
          type="number"
          hide-details
          label="Carga Horária"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="form.initials"
          type="text"
          hide-details
          label="Sigla"
          outlined
          dense
          @input="
            (v) => {
              form.initials = v.toUpperCase()
            }
          "
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-color-picker
          v-model="form.color"
          dot-size="25"
          swatches-max-height="200"
          mode="rgb"
        ></v-color-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-btn dark color="primary" text @click="close()"> Sair </v-btn>
      <v-btn dark color="blue darken-1" @click="setSubmit()"> Salvar </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormScales',
  props: {
    closeDialog: {
      type: Function,
      default: () => {},
    },
    editData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      form: {
        color: { r: '', g: '', b: '', a: '' },
      },
    }
  },
  computed: {},
  watch: {
    editData: function () {
      if (this.editData.name) {
        this.form = { ...this.editData }
        this.form.color = this.colorAdaptReceive(this.form.color)
      } else {
        this.form = {
          color: { r: '', g: '', b: '', a: '' },
        }
      }
    },
  },
  mounted: function () {
    if (this.editData.name) {
      this.form = { ...this.editData }
      this.form.color = this.colorAdaptReceive(this.form.color)
    } else {
      this.form = {
        color: { r: '', g: '', b: '', a: '' },
      }
    }
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('utils', ['ActionStoreScale', 'ActionUpdateScale']),
    async save() {
      if (
        this.form.name !== '' &&
        this.form.workload >= 0 &&
        this.form.initials !== '' &&
        this.form.color !== ''
      ) {
        this.ActionSetLoading(true)
        try {
          let color = this.colorAdapterSend(this.form.color)
          await this.ActionStoreScale({ ...this.form, color })
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Escala cadastrada com sucesso',
          })
          this.close()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível cadastrar escala.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    async update() {
      if (
        !this.form.name &&
        this.form.workload >= 0 &&
        this.form.initials !== '' &&
        this.form.color !== ''
      ) {
        return
      } else {
        this.ActionSetLoading(true)
        try {
          let color = this.colorAdapterSend(this.form.color)
          await this.ActionUpdateScale({ ...this.form, color })
          this.$swal({
            icon: 'success',
            title: 'Atualizado',
            text: 'Escala atualizada com sucesso.',
          })
          this.closeDialog()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível atualizar escala.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    close() {
      this.closeDialog()
      this.form = {}
    },
    setSubmit() {
      if (!this.editData.name) {
        this.save()
      } else {
        this.update()
      }
    },
    colorAdaptReceive(color) {
      let regex = /( )|[a-z]|\(|\)/g
      let new_color = color.replace(regex, '').split(',')
      new_color = {
        r: new_color[0],
        g: new_color[1],
        b: new_color[2],
        a: '',
      }
      return new_color
    },
    colorAdapterSend(color) {
      let new_color = `rgb(${color.r},${color.g},${color.b})`
      return new_color
    },
  },
}
</script>


